import PersonalInfoPage from '@/pages/PersonalInfoPage.vue';
import LandingPage from '@/pages/LandingPage.vue';
import InsuranceTypePage from '@/pages/InsuranceTypePage.vue';
import InsuranceReasonPage from '@/pages/InsuranceReasonPage.vue';
import ContactInfoPage from '@/pages/ContactInfoPage.vue';
import IdentityVerificationPage from '@/pages/IdentityVerificationPage.vue';
import IncomeSourcePage from '@/pages/IncomeSourcePage.vue';
import PersonAddressPage from '@/pages/PersonAddressPage.vue';
import NextInsuranceTypePage from '@/pages/family/NextInsuranceTypePage.vue';
import PassDeliveryPage from '@/pages/PassDeliveryPage.vue';
import SummaryPage from '@/pages/SummaryPage.vue';
import DocumentPage from '@/pages/DocumentPage.vue';
import SigningPage from '@/pages/SigningPage.vue';

export default [
  {
    name: 'root',
    path: '/',
    redirect: '/landing-page',
    meta: {
      redirectEN: '/landing-page',
      redirectUA: '/landing-page',
      redirectRU: '/landing-page',
    },
  },
  {
    name: 'Step1',
    path: '/landing-page',
    component: LandingPage,
    meta: {
      pathEN: '/landing-page',
      pathUA: '/landing-page',
      pathRU: '/landing-page',
      step: 1,
      icon: 'todo',
      labelSK: 'Landing page',
      labelEN: 'Landing page',
      labelUA: 'Landing page',
      labelRU: 'Landing page',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'Step2',
    path: '/vyber-poistenca',
    component: InsuranceTypePage,
    meta: {
      pathEN: '/vyber-poistenca',
      pathUA: '/vyber-poistenca',
      pathRU: '/vyber-poistenca',
      step: 2,
      icon: 'todo',
      labelSK: 'Vyber poistenca',
      labelEN: 'Vyber poistenca',
      labelUA: 'Vyber poistenca',
      labelRU: 'Vyber poistenca',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'Step3',
    path: '/dovod-poistenia',
    component: InsuranceReasonPage,
    meta: {
      pathEN: '/dovod-poistenia',
      pathUA: '/dovod-poistenia',
      pathRU: '/dovod-poistenia',
      step: 3,
      icon: 'todo',
      labelSK: 'Dovod poistenia',
      labelEN: 'Dovod poistenia',
      labelUA: 'Dovod poistenia',
      labelRU: 'Dovod poistenia',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'Step4',
    path: '/kontaktne-udaje',
    component: ContactInfoPage,
    meta: {
      pathEN: '/kontaktne-udaje',
      pathUA: '/kontaktne-udaje',
      pathRU: '/kontaktne-udaje',
      step: 4,
      icon: 'todo',
      labelSK: 'Kontaktné údaje',
      labelEN: 'Kontaktné údaje',
      labelUA: 'Kontaktné údaje',
      labelRU: 'Kontaktné údaje',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'Step5',
    path: '/osobne-udaje',
    component: PersonalInfoPage,
    meta: {
      pathEN: '/osobne-udaje',
      pathUA: '/osobne-udaje',
      pathRU: '/osobne-udaje',
      step: 5,
      icon: 'todo',
      labelSK: 'Osobné údaje',
      labelEN: 'Osobné údaje',
      labelUA: 'Osobné údaje',
      labelRU: 'Osobné údaje',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'ADULT',
    },
  },
  {
    name: 'Step6',
    path: '/overenie-totoznosti',
    component: IdentityVerificationPage,
    meta: {
      pathEN: '/overenie-totoznosti',
      pathUA: '/overenie-totoznosti',
      pathRU: '/overenie-totoznosti',
      step: 6,
      icon: 'todo',
      labelSK: 'Overenie totoznosti',
      labelEN: 'Overenie totoznosti',
      labelUA: 'Overenie totoznosti',
      labelRU: 'Overenie totoznosti',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'ADULT',
    },
  },
  {
    name: 'Step7',
    path: '/aktualny-zdroj-prijmu',
    component: IncomeSourcePage,
    meta: {
      pathEN: '/aktualny-zdroj-prijmu',
      pathUA: '/aktualny-zdroj-prijmu',
      pathRU: '/aktualny-zdroj-prijmu',
      step: 7,
      icon: 'todo',
      labelSK: 'Aktualny zdroj prijmu',
      labelEN: 'Aktualny zdroj prijmu',
      labelUA: 'Aktualny zdroj prijmu',
      labelRU: 'Aktualny zdroj prijmu',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'ADULT',
    },
  },
  {
    name: 'Step8',
    path: '/udaje-o-pobyte',
    component: PersonAddressPage,
    meta: {
      pathEN: '/udaje-o-pobyte',
      pathUA: '/udaje-o-pobyte',
      pathRU: '/udaje-o-pobyte',
      step: 8,
      icon: 'todo',
      labelSK: 'Udaje o pobyte',
      labelEN: 'Udaje o pobyte',
      labelUA: 'Udaje o pobyte',
      labelRU: 'Udaje o pobyte',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'ADULT',
    },
  },
  {
    name: 'Step9',
    path: '/vyber-poistenca-family',
    component: NextInsuranceTypePage,
    meta: {
      pathEN: '/vyber-poistenca-family',
      pathUA: '/vyber-poistenca-family',
      pathRU: '/vyber-poistenca-family',
      step: 9,
      icon: 'todo',
      labelSK: 'Vyber poistenca',
      labelEN: 'Vyber poistenca',
      labelUA: 'Vyber poistenca',
      labelRU: 'Vyber poistenca',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'FAMILY',
    },
  },
  {
    name: 'Step10',
    path: '/dorucenie-preukazu-poistenca',
    component: PassDeliveryPage,
    meta: {
      pathEN: '/dorucenie-preukazu-poistenca',
      pathUA: '/dorucenie-preukazu-poistenca',
      pathRU: '/dorucenie-preukazu-poistenca',
      step: 17,
      icon: 'todo',
      labelSK: 'Dorucenie preukazu poistenca',
      labelEN: 'Dorucenie preukazu poistenca',
      labelUA: 'Dorucenie preukazu poistenca',
      labelRU: 'Dorucenie preukazu poistenca',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'Step11',
    path: '/zhrnutie',
    component: SummaryPage,
    meta: {
      pathEN: '/zhrnutie',
      pathUA: '/zhrnutie',
      pathRU: '/zhrnutie',
      step: 18,
      icon: 'todo',
      labelSK: 'Zhrnutie',
      labelEN: 'Zhrnutie',
      labelUA: 'Zhrnutie',
      labelRU: 'Zhrnutie',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'Step12',
    path: '/dokumenty',
    component: DocumentPage,
    meta: {
      pathEN: '/dokumenty',
      pathUA: '/dokumenty',
      pathRU: '/dokumenty',
      step: 19,
      icon: 'todo',
      labelSK: 'Dokumenty',
      labelEN: 'Dokumenty',
      labelUA: 'Dokumenty',
      labelRU: 'Dokumenty',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'COMMON',
    },
  },
  {
    name: 'Step13',
    path: '/podpisanie',
    component: SigningPage,
    meta: {
      pathEN: '/podpisanie',
      pathUA: '/podpisanie',
      pathRU: '/podpisanie',
      step: 20,
      icon: 'todo',
      labelSK: 'Podpisanie',
      labelEN: 'Podpisanie',
      labelUA: 'Podpisanie',
      labelRU: 'Podpisanie',
      ga: {
        virtualPagePath: '/uzp/todo',
        virtualPageTitle: 'TODO',
      },
      routeStepType: 'COMMON',
    },
  },
];
